import React from "react";
import { Box, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useGridApiContext } from "@mui/x-data-grid-pro";

const DetailPanel = ({ row }) => {
  const apiRef = useGridApiContext();

  const handleClose = () => {
    apiRef.current.toggleDetailPanel(row.id);
  };

  const insertedDate = new Date(row.inserted).toLocaleString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });

  const contactCount = row.recordedContacts?.length || 0;
  const callCount = row.recordedCallCount || 0;

  return (
    <Box sx={{ p: 2, position: "relative" }}>
      <IconButton
        onClick={handleClose}
        size="small"
        sx={{ position: "absolute", top: 8, right: 8 }}
      >
        <CloseIcon />
      </IconButton>

      <Typography variant="h6" gutterBottom>
        Playlist Summary
      </Typography>
      <Typography variant="body1" gutterBottom>
        This playlist was created on <strong>{insertedDate}</strong> by{" "}
        <strong>{row.createdBy}</strong>. It contains{" "}
        <strong>{callCount}</strong> recorded call{callCount !== 1 ? "s" : ""},
        involving <strong>{contactCount}</strong> recorded contact
        {contactCount !== 1 ? "s" : ""}.
      </Typography>
      <Typography variant="body1" gutterBottom>
        The playlist is currently{" "}
        {row.status === "reviewed" ? (
          <>
            <strong>reviewed</strong> by <strong>{row.reviewedBy}</strong>
          </>
        ) : (
          <strong>pending review</strong>
        )}
        , of type <strong>{row.type?.toLowerCase()}</strong>, and is marked as{" "}
        <strong>{row.isPublic ? "public" : "private"}</strong>.
      </Typography>

      <Typography variant="body2" sx={{ mt: 2 }}>
        <em>Last updated: {new Date(row.updated).toLocaleString("en-GB")}</em>
      </Typography>
    </Box>
  );
};

export default DetailPanel;
